import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/live';
import * as css from './TicketDetails.css';

interface TicketDetailsStubProps {
    onMoreInfo?: () => void;
    onSeatMap?: () => void;
    /* timetable events: opens the list of sessions booked on this ticket */
    onSchedule?: () => void;
}

function TicketDetailsStub({onMoreInfo, onSeatMap, onSchedule}: TicketDetailsStubProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.stub>
            {onMoreInfo && (
                <Button variant="neutral" size="chip" inverse customStyle={{background: 'transparent'}} onClick={onMoreInfo} data-cy="more-info-button">
                    {t('moreInfo')}
                </Button>
            )}
            {onSeatMap && (
                <Button variant="neutral" size="chip" inverse customStyle={{background: 'transparent'}} onClick={onSeatMap} data-cy="seat-map-button">
                    {t('seatMap')}
                </Button>
            )}
            {onSchedule && (
                <Button variant="neutral" size="chip" inverse customStyle={{background: 'transparent'}} onClick={onSchedule} data-cy="schedule-button">
                    {t('schedule')}
                </Button>
            )}
        </css.stub>
    );
}

export default TicketDetailsStub;
